<div class="paybee-modal-header">
    <div class="row">
        <div class="col-10">
            <div class="modal-main-heading">Add Donation</div>
        </div>
        <div class="col-2">
            <button type="button" class="close cursor--pointer" (click)="close()">
                <span aria-hidden="true" class="black-text cursor--pointer">×</span>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="modal-sub-heading">This Donation will be added to <b>{{data.displayName}}</b></div>
        </div>
    </div>
</div>

<div class="modal-body custom-material-form modal-p2p-padding" [formGroup]="addP2pDonationForm">
    <div class="row">
        <div class="col-6">
            <mdb-form-control class="form-fill form-fill--p2p">
                <input
                    mdbInput
                    formControlName="name"
                    (ngModelChange)="searchDonor($event, 1); isAddActive = true"
                    [mdbAutocomplete]="autocompleteName"
                    (focus)="onInputFocus()"
                    maxlength="128"
                    (keydown.enter)="passOption($event)"
                    type="text"
                    id="autocompleteName"
                />
                <label mdbLabel [ngClass]="{'active': isNamelInputLabelActive}" class="inputLabel" for="autocompleteName">Name</label>
                @if(addP2pDonationForm.controls.name.hasError('required') && addP2pDonationForm.controls.name.touched) {
                    <span class="form-fill-error--p2p ml-0">Invalid Name</span>
                }
            </mdb-form-control>
            <mdb-autocomplete #autocompleteName="mdbAutocomplete" >
                @for(option of searchResult; track option.data.id) {
                    <mdb-option [value]="option.searchString" (click)="passOption($event)">
                        {{ option.searchString }}
                    </mdb-option>
                }
                @if(notFound) {
                    <div class="autocomplete-no-results d-none">No Results Found</div>
                }
            </mdb-autocomplete>
        </div>

        <div class="col-6">
            <mdb-form-control class="form-fill form-fill--p2p">
                <input
                    mdbInput
                    formControlName="email"
                    (ngModelChange)="searchDonor($event, 0); isAddActive = true"
                    [mdbAutocomplete]="autocompleteEmail"
                    (focus)="onInputFocus()"
                    (keydown.enter)="passOption($event)"
                    type="text"
                    id="autocompleteEmail"
                />
                <label mdbLabel [ngClass]="{'active': isemailLabelActive}" data-error="" class="inputLabel" for="autocompleteEmail">Email</label>
                @if(addP2pDonationForm.controls.email.invalid && addP2pDonationForm.controls.email.touched) {
                    <span class="form-fill-error--p2p ml-0">Invalid Email</span>
                }
            </mdb-form-control>

            <mdb-autocomplete #autocompleteEmail="mdbAutocomplete">
                @for(option of searchResult; track option.data.id) {
                    <mdb-option [value]="option.searchString" (click)="passOption($event)">
                        {{ option.searchString }}
                    </mdb-option>
                }
                @if(notFound) {
                    <div class="autocomplete-no-results d-none">No Results Found</div>
                }
            </mdb-autocomplete>
        </div>
    </div>

    <div class="row">
        <div class="col-6">
            <div class="form-fill form-fill--p2p">
                <input
                    id="p2pAmount"
                    currencyMask
                    formControlName="amount"
                    (ngModelChange)="isAddActive = true"
                    (focus)="onInputFocus()"
                    required
                    type="text"
                    class="active"
                >
                <label mdbLabel class="inputLabel active" for="p2pAmount">Amount</label>
                @if(addP2pDonationForm.controls.amount.invalid && addP2pDonationForm.controls.amount.touched) {
                    <span class="form-fill-error--p2p position-absolute ml-0">Incorrect Amount</span>
                }
            </div>
        </div>

        <div class="col-6">
            <div class="md-form">
                <input 
                    mdbInput 
                    #dateInput 
                    type="text" 
                    id="p2pDonationDate" 
                    class="form-control datepicker cursor--pointer"
                    style="background-color: #f1f1f1!important;"
                >
                <label mdbLabel data-error="Invalid Date" class="disabled" for="p2pDonationDate">Donation Date</label>
                <i class="far fa-calendar-alt calendar-icon--paybee cursor--pointer" onclick="document.getElementById('p2pDonationDate').focus()"></i>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-6">
            <mdb-form-control class="form-fill">
                <mdb-select formControlName="paymentMethod" (click)="onInputFocus()" class="mdb-select">
                    @for(option of donateOptions; track option.id) {
                        <mdb-option [value]="option.id">{{option.label}}</mdb-option>
                    }
                </mdb-select>
                <label mdbLabel class="form-label form-label--paybee">Payment Method</label>
                @if(addP2pDonationForm.controls.paymentMethod.touched && addP2pDonationForm.controls.paymentMethod.invalid) {
                    <span class="form-fill-error m-0">Choose Payment Method</span>
                }
            </mdb-form-control>
        </div>
    </div>

    @if(streetAddressRequired) {
        <h6 class="text-left">{{campaignData.streetAddressReason}}</h6>
        <div class="row">
            <div class="col-6">
                <mdb-form-control class="form-fill appGoogleMapsAutocomplete d-flex">
                    <app-mdb-input-google-maps-autocomplete
                        id="p2pAppGoogleMapsAutocomplete"
                        mdbInput
                        autocomplete="address"
                        label="Address"
                        class="d-flex w-100"
                        [formControl]="addressInput"
                    ></app-mdb-input-google-maps-autocomplete>
                </mdb-form-control>
                @if(addP2pDonationForm.controls.addressInput.invalid && addP2pDonationForm.controls.addressInput.touched) {
                    <div class="mt-n4">
                        <span class="form-fill-error ml-0">
                            Street address required, Please select one or
                            <span (click)="openStreetAddressModal()" class="caption link-element">Enter Manually</span>
                        </span>
                    </div>
                }
            </div>
            <div class="col-6">
                <mdb-form-control class="form-fill">
                    <app-mdbp-input 
                        mdbInput 
                        formControlName="addressUnit" 
                        [showMaxLength]="false"
                        label='Unit/Apartment# (optional)'>
                    </app-mdbp-input>
                </mdb-form-control>
            </div>
        </div>
    }

    @if(phoneNumRequired) {
        <mdb-form-control class="form-fill" >
            <app-mdbp-input mdbInput formControlName="phone" autocomplete="tel" type='tel' [showMaxLength]="false" phoneInputMask="on" label='Phone Number'></app-mdbp-input>
            @if(addP2pDonationForm.controls.phone.touched && addP2pDonationForm.controls.phone.invalid) {
                <span class="form-fill-error m-0">Please provide correct Number</span>
            }
        </mdb-form-control>
    }

    @if(additionalInfoRequired) {
        <h6 class="text-left">{{campaignData.additionalInfoDetail}}</h6>
        <mdb-form-control class="form-fill">
            <app-mdbp-input 
                mdbInput 
                formControlName="addInfo" 
                maxLength="512"
                label= "{{campaignData.additionalInfoDesc}}">
            </app-mdbp-input>
            @if(addP2pDonationForm.controls.addInfo.invalid && addP2pDonationForm.controls.addInfo.touched) {
                <span class="form-fill-error ml-0">Info required</span>
            }
        </mdb-form-control>
    }

    @if(additionalInfoSelectRequired) {
        <h6 class="text-left">{{campaignData.additionalInfoSelectDesc}}</h6>
        <mdb-form-control class="form-fill">
            <mdb-select formControlName="addInfoSelect" (click)="onInputFocus()" class="mdb-select">
                @for(option of campaignData.additionalInfoSelect; track option.id) {
                    <mdb-option [value]="option">{{option}}</mdb-option>
                }    
            </mdb-select>
            <label mdbLabel class="form-label form-label--paybee">Select one</label>
            @if(addP2pDonationForm.controls.addInfoSelect.invalid && addP2pDonationForm.controls.addInfoSelect.touched) {
                <span class="form-fill-error ml-0">No option selected</span>
            }
        </mdb-form-control>
    }

    <div class="divider mb-4"></div>
    <div class="switch switch--paybee ml-n2 mb-3">
        <label>
            <input #addMemoP2P type="checkbox" (click)="getCheckboxValue()">
            <span class="lever"></span> Add memo
        </label>
    </div>

    @if(showMemo) {
        <mdb-form-control class="form-fill">
            <app-mdbp-input mdbInput 
                formControlName="memoInput"
                id="p2pMemo" 
                maxLength="256" 
                [showMaxLength]="false"
                label="Memo (optional)"
            ></app-mdbp-input>
        </mdb-form-control>
    }
</div>

<div class="modal-footer paybee-modal-footer">
    <a class="btn btn-sm modal-cancel-button waves-effect waves-light" (click)="close()">Cancel</a>
    <a class="btn btn-sm modal-confirm-button waves-effect waves-light" [ngClass]="{'disabled': !isAddActive}" (click)="addDonation()">Add</a>
</div>